import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import WizardStepContainer from '../WizardStepContainer';
import { WizardStylesContext } from '../WizardStylesContext';
import WizardStepButtons from '../WizardStepButtons';
import ChoicePills from '../../Buttons/ChoicePills';
import CommentBox from '../../../containers/CommentBox/CommentBox';
import { formMarketAddInvestibleLink, navigate } from '../../../utils/marketIdPathFunctions';
import { useHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { REPLY_TYPE, SUGGEST_CHANGE_TYPE, TODO_TYPE } from '../../../constants/comments';
import _ from 'lodash';
import { moveToDiscussion } from '../../../contexts/CommentsContext/commentsContextHelper';
import { CommentsContext } from '../../../contexts/CommentsContext/CommentsContext';
import { OperationInProgressContext } from '../../../contexts/OperationInProgressContext/OperationInProgressContext';

function BugDecisionStep (props) {
  const { marketId, comment, comments, updateFormData = () => {}, formData = {} } = props;
  const [commentsState, commentsDispatch] = useContext(CommentsContext);
  const [, setOperationRunning] = useContext(OperationInProgressContext);
  const history = useHistory();
  const classes = useContext(WizardStylesContext);
  const allowedTypes = ['Suggestion', 'Discussion'];
  if (comment.comment_type === SUGGEST_CHANGE_TYPE) {
    allowedTypes.push('Task');
  } else if (comment.comment_type === TODO_TYPE) {
    allowedTypes.unshift('Task');
  } else if (comment.comment_type === REPLY_TYPE) {
    allowedTypes.unshift('Task');
  }
  allowedTypes.push('Bug');
  const { useCompression, useType } = formData;
  function doesTypeMatch(checkType) {
    return comment.comment_type === TODO_TYPE ? checkType === 'Task' :
      (comment.comment_type === SUGGEST_CHANGE_TYPE && ['Suggestion', 'Discussion'].includes(checkType));
  }
  const isSameType = doesTypeMatch(useType);

  function getNextFunction() {
    if (useType === 'Discussion') {
      return () => moveToDiscussion(comment, commentsState, commentsDispatch, setOperationRunning, history);
    }
    if (!isSameType) {
      return undefined;
    }
    return () => navigate(history,
      `${formMarketAddInvestibleLink(marketId, comment.group_id)}&fromCommentId=${comment.id}&commentType=${useType}`);
  }
  const isFinal = isSameType || useType === 'Discussion';
  return (
    <WizardStepContainer
      {...props}
      isLarge
    >
      <Typography className={classes.introText}>
        Move to what?
      </Typography>
      <CommentBox
        comments={comments}
        marketId={marketId}
        allowedTypes={[]}
        isInbox
        compressAll
        inboxMessageId={comment?.id}
        displayRepliesAsTop={comment.comment_type === REPLY_TYPE}
        removeActions
        toggleCompression={() => updateFormData({ useCompression: !useCompression })}
        useCompression={useCompression}
      />
      <div style={{marginBottom: '2rem'}} />
      <ChoicePills
        ariaLabel="type-choice"
        value={useType || ''}
        onChange={(value) => updateFormData({ useType: value })}
        options={allowedTypes.map((objectType) => ({
          value: objectType,
          id: `type${objectType}`,
          label: <FormattedMessage id={doesTypeMatch(objectType) ? `${objectType}OtherMoveLabel` : `${objectType}Label`} />,
        }))}
      />
      <div className={classes.borderBottom}/>
      <WizardStepButtons
        {...props}
        validForm={!_.isEmpty(useType)}
        onNext={getNextFunction()}
        isFinal={isFinal}
        onNextDoAdvance={!isFinal}
        onNextSkipStep={useType === 'Bug'}
        spinOnClick={false}
      />
    </WizardStepContainer>
  );
}

BugDecisionStep.propTypes = {
  updateFormData: PropTypes.func,
  formData: PropTypes.object
};

export default BugDecisionStep;